import { html as a, children as c, elements as n, repeat as o, when as i, ref as s } from "@microsoft/fast-element";
import { fillTemplate as l } from "../common/fill-template.js";
const r = a` <div
  class="legend-item"
  @mouseover="${(e, t) => t.parent.onLegendItemMouseover(t, t.index)}"
  @mouseout="${(e, t) => t.parent.onLegendItemMouseout()}"
  role="listitem"
  @keydown="${(e, t) => t.parent.onLegendKeyDown(t)}"
  tabindex="0"
>
  <div class="legend-dot" style="background-color: ${(e) => e.color}"></div>
  <div
    class="legend-label"
    @mouseout="${(e, t) => t.parent.onLegendItemMouseout()}"
    role="button"
    aria-label="${(e, t) => t.parent.accessibility && t.parent.accessibility.chartLegendItemTemplate ? l(t.parent.accessibility.chartLegendItemTemplate, {
  label: e.label,
  value: e.value
}) : `${e.label} : ${e.value}.`}"
  >
    ${(e) => e.label}
  </div>
</div>`, d = a` <div
  class="legend-list"
  @mouseout="${(e) => e.onLegendItemMouseout()}"
  ${c({ property: "legendItems", filter: n("div.legend-item") })}
  role="list"
  tabindex="0"
>
  ${o((e) => e.chartData, a` ${r} `, {
  positioning: !0
})}
</div>`, m = a`
  <div class="control" part="control">
    ${i(
  (e) => e.accessibility && e.chartData.length,
  a` <div aria-hidden="false" class="accessibility-content">
        ${(e) => l(e.accessibility.chartStartTemplate, {
    chartName: e.accessibility.chartTitle,
    slicesCount: e.chartData.length
  })}
      </div>`
)}
    ${i(
  (e) => e.accessibility && !e.chartData.length,
  a` <div aria-hidden="false" class="accessibility-content">
        ${(e) => e.accessibility.emptyChart}
      </div>`
)}

    <div class="chart-container">
      <div class="chart-content">
        ${i((e) => e.showLegend, d)}
        <div class="chart-canvas-wrapper" @mouseout="${(e) => e.resetHover()}">
          <div class="chart-canvas-inner-wrapper">
            <canvas
              ${s("canvas")}
              class="chart-canvas"
              @contextmenu="${(e, t) => e.onContextMenu(t)}"
            >
            </canvas>
          </div>
          <div class="tooltip" ${s("tooltipRef")} aria-hidden="true">
            <p class="tooltip-title">${(e) => e.tooltip.title}</p>
            <p class="tooltip-label">${(e) => e.tooltip.label}</p>
          </div>
        </div>
      </div>
    </div>

    ${i(
  (e) => e.accessibility,
  a`
        <div aria-hidden="false" class="accessibility-content">
          ${(e) => l(e.accessibility.chartEndTemplate, {
    chartName: e.accessibility.chartTitle
  })}
        </div>
      `
)}
  </div>
`;
export {
  m as pieChartTemplate
};
